/**
 * Template - Data mapper for RFI1 - Finished Good
 * Section UID (in template) : Section Path in data
 */
export const rfi1FinishedGoodSectionMapper = {
  //Business Capabilities
  total_product_capabilities:
    'dynamic_sections.business_capability.total_product_capabilities',
  upload_documents_images_video:
    'dynamic_sections.business_capability.upload_documents_images_video',
  certifications: 'dynamic_sections.business_capability.certifications',
  product_gender_strength:
    'dynamic_sections.business_capability.product_gender_strength',
  innovation_core_competencies:
    'dynamic_sections.business_capability.innovation_core_competencies',
  quality_management: 'dynamic_sections.business_capability.quality_management',
  design_competency: 'dynamic_sections.business_capability.design_competency',
  food_safety_quality_regulatory:
    'dynamic_sections.business_capability.food_safety_quality_regulatory',
  food_packaging_product_capabilities:
    'dynamic_sections.business_capability.food_packaging_product_capabilities',
  beauty_formulation_capabilities:
    'dynamic_sections.business_capability.beauty_formulation_capabilities',
  beauty_packaging_capabilities:
    'dynamic_sections.business_capability.beauty_packaging_capabilities',
  product_formulation:
    'dynamic_sections.business_capability.product_formulation',
  finishedgood_color_capabilities: 'dynamic_sections.business_capability.finishedgood_color_capabilities',

  //Supply Chain
  top_countries_of_production:
    'dynamic_sections.supply_chain.top_countries_of_production',
  distribution_and_logistics:
    'dynamic_sections.supply_chain.distribution_and_logistics',
  lead_time: 'dynamic_sections.supply_chain.lead_time',
  fda: 'dynamic_sections.supply_chain.fda',
  shipment_capabilities: 'dynamic_sections.supply_chain.shipment_capabilities',
  minimum_order_quantity:
    'dynamic_sections.supply_chain.minimum_order_quantity',

  //Responsible Sourcing
  responsible_sourcing_sustainability:
    'dynamic_sections.responsible_sourcing.responsible_sourcing_sustainability',

  //Other Information
  key_supplier_contact_information:
    'dynamic_sections.other_information.key_supplier_contact_information',
  business_structure: 'dynamic_sections.other_information.business_structure',
  assign_supplier_contacts:
    'dynamic_sections.other_information.assign_supplier_contacts',
  top_retail_and_brands_and_business_value:
    'dynamic_sections.other_information.top_retail_and_brands_and_business_value',
  employees: 'dynamic_sections.other_information.employees',
  broker_details: 'dynamic_sections.other_information.brokerDetails',
  retailers_produce_private_label:
    'dynamic_sections.other_information.retailers_produce_private_label',
  food_and_beverage_employee_information:
    'dynamic_sections.other_information.food_and_beverage_employee_information',
}
